import React, { Component } from 'react';

//regex email string
import {
    emailRegex
} from "../../../static_data/static_strings";

import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";


/*
    props: 
        className => to format
        name => name of input
        placeholder => placeholder text
        value => value of text that is directly set and changes upon parent
        required => true/false sets the required field for input text
        disabled => true/false disabling box
        onChangeSetParentState => call back function to set the parent state using this state's value
        inputType => type of the textbox: email, tel, number, text
        latinOnly => true/false only allow latin characters or not
        notAllowedCharacter => {char} not allow specific char
*/

class TextBox extends Component {

    state = {
        type: "text",
        pattern: undefined,
        containNonLatin: false,
        oldVal: ""
    }

    constructor(props) {
        super(props);

        //refs
        this.toastRef = React.createRef();

        //bind functions
        this.handleOnChange = this.handleOnChange.bind(this);
        this.setInputRegexType = this.setInputRegexType.bind(this);
        this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);

        //helper function
        this.checkIfValidEmailRegex = this.checkIfValidEmailRegex.bind(this);

        //init set the regex type of this 
        this.setInputRegexType();
    }

    setInputRegexType() {
        if (!isEmpty(this.props.inputType)) {
            var inputType = this.props.inputType.toLowerCase();

            //if email, set pattern to email regex
            if (inputType === "email") {
                //this.state.type = "email";
                this.state.pattern = emailRegex;
                //"[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$";
            }

            //if phone, set pattern to phone regex: allow only 0-9, +, -, ., (, ),
            else if (inputType === "tel") {
                //this.state.type = "tel";
                //this.state.pattern = "[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$";
            }

            //if number
            else if (inputType === "number") {
                this.state.type = "number";
            }
        }
    }

    //prevent keys from press on key down
    handleOnKeyDown(event) {

        if (!isEmpty(this.props.inputType)) {
            var inputType = this.props.inputType.toLowerCase();

            var currentKey = event.keyCode;

            //if tel, disable keys other than: 0-9 [48 to 57], - [189], . [190], + [187], ( [57], ) [48], backspace [8]
            // if(inputType === "tel") {
            //     if ((currentKey < 48 || 57 < currentKey) 
            //         && (currentKey < 96 || 105 < currentKey) // numpad numbers enable numpad for firefox
            //         && currentKey !== 107 // numpad +
            //         && currentKey !== 109 // numpad -
            //         && currentKey !== 110 // numpad .
            //         && (currentKey !== 189 && !event.shiftKey)
            //         && currentKey !== 190 
            //         && (currentKey !== 187 && !event.shiftKey)
            //         && currentKey !=!= 8) {
            //        event.preventDefault();
            //    }
            // }
            //key code for , is 188
            if (inputType === "institution") {
                if (currentKey === 188) {
                    event.preventDefault();
                }
            }
        }
    }

    checkIfValidEmailRegex(test_str) {
        var pattern = new RegExp(emailRegex);
        return pattern.test(test_str);
    }


    handleOnChange(event) {
        let val = event.target.value;
        const notAllowedCharacter = this.props.notAllowedCharacter == undefined? "" : this.props.notAllowedCharacter; // default notAllowedChar = ""
        var currVal = val.replace(notAllowedCharacter, "");

        const rforeign = /[^\u0000-\u007f]/;
        let latinOnly = this.props.latinOnly == undefined? false : this.props.latinOnly
        this.state.containNonLatin = latinOnly && rforeign.test(currVal);

        if (!isEmpty(this.props.inputType)) {
            const inputType = this.props.inputType.toLowerCase();
            if (inputType === 'tel') {
                if (/^[()+-.0-9]*$/.test(currVal)) {
                    this.state.oldVal = currVal;
                } else {
                    currVal = this.state.oldVal;
                }
            }
        }

        //set the value at the parent if the set function exists
        if (this.props.onChangeSetParentState) {
            this.props.onChangeSetParentState(currVal, this.props.name);
        }
    }

    handleOnBlur(event) {
        //if email, and required, and syntax of email is invalid, display toast and empty out value
        if (this.props.inputType === "email" 
            && this.props.required
            && !isEmpty(this.props.value)
            && !this.checkIfValidEmailRegex(this.props.value) 
        ) {
            //display toast
            this.toastRef.current.show({ severity: 'error', summary: 'Invalid Email', detail: "Your Email is invalid, please enter a valid email." });

            //set the value at the parent if the set function exists
            if (this.props.onChangeSetParentState) {
                this.props.onChangeSetParentState("", this.props.name);
            }
        }

        if(
            this.props.hasOwnProperty('trimValue') && 
            this.props.trimValue === false
        ) {
            return
        } else {
            if(Object.prototype.toString.call(this.props.value) === "[object String]") {
                this.props.onChangeSetParentState(this.props.value.trim(), this.props.name)
            }
        }
    }

    render() { 
        return (  
            <React.Fragment>
                <Growl
                    ref={this.toastRef}
                    baseZIndex={9000}
                    life={12000}
                    position={"topright"}
                />
                
                <input 
                    value={!isEmpty(this.props.value) ? this.props.value : ""}
                    type={this.state.type}
                    className={"p-inputtext p-component " + (!isEmpty(this.props.className) ? this.props.className : "")} 
                    name={this.props.name} 
                    required={(!isEmpty(this.props.required) ? this.props.required : false)}
                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                    placeholder={this.props.placeholder}
                    maxLength={this.props.maxLength}
                    pattern={this.state.pattern}
                    onKeyDown={(e) => this.handleOnKeyDown(e)}
                    onChange={(e) => this.handleOnChange(e)} 
                    onBlur={(e) => this.handleOnBlur(e)}
                />
                {(!isEmpty(this.props.value) && this.state.containNonLatin) ?
                    <span className={"autocomplete_error_msg_padding"}>
                        <Message severity="error" text="Only Latin characters allowed" />
                    </span>
                    : null}
               
            </React.Fragment>
        );
    }
}
 
export default TextBox;